"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enterpriseQuoteService = void 0;
const enterprise_quote_service_1 = require("./enterprise-quote-service");
const query_client_1 = require("../query-client");
exports.enterpriseQuoteService = new enterprise_quote_service_1.EnterpriseQuoteService({
    resource: 'enterprise-quote',
    parentResources: [],
    middleware: [],
    queryClient: query_client_1.queryClient,
});
